import { AccountCategory } from "../model";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";

export async function getAccountCategoryById(id: number | string): Promise<AccountCategory | void> {
  const localApi = await getLocalApi();

  return await localApi.fetchSingle(
    (apiConfig as any).reference_data_account_category_by_id.replace("{categoryId}", String(id)),
    mapAccountCategory,
    "Failed to fetch Account Category by id"
  );
}

function mapAccountCategory(dto: any): AccountCategory {
  return {
    id: dto?.id ?? dto?.categoryId ?? dto?.accountCategoryId ?? 0,
    name: dto?.name ?? dto?.categoryName ?? "",
    createdBy: dto?.createdBy ?? "",
    lastModifiedBy: dto?.lastModifiedBy ?? "",
    active: typeof dto?.active === "boolean" ? dto.active : !!dto?.isActive,
    divisionId: dto?.divisionId ?? dto?.division?.id ?? 0,
  };
}